'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _singleAndDoubleClick = require('./singleAndDoubleClick');

var _singleAndDoubleClick2 = _interopRequireDefault(_singleAndDoubleClick);

var _queryparamGetter = require('./queryparam.getter.js');

var _queryparamGetter2 = _interopRequireDefault(_queryparamGetter);

require('moment');

var _iceSafeApply = require('./iceSafeApply');

var _iceSafeApply2 = _interopRequireDefault(_iceSafeApply);

var _hostGetter = require('./host.getter.js');

var _hostGetter2 = _interopRequireDefault(_hostGetter);

var _cookies = require('./cookies');

var _cookies2 = _interopRequireDefault(_cookies);

var _Base64StringUtil = require('./Base64StringUtil');

var _Base64StringUtil2 = _interopRequireDefault(_Base64StringUtil);

var _passwordGeneratorService = require('./passwordGeneratorService.js');

var _passwordGeneratorService2 = _interopRequireDefault(_passwordGeneratorService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ice-utils.services', []).factory('singleAndDoubleClickHelper', _singleAndDoubleClick2.default).factory('iceSafeApply', _iceSafeApply2.default).factory('hostGetter', _hostGetter2.default).factory('cookies', _cookies2.default).factory('iceBase64StringUtil', _Base64StringUtil2.default).service('iceGeneratorPasswordService', _passwordGeneratorService2.default).factory('_', function () {
  return _;
}).factory('q', function q() {
  return q;
}).factory('Q', function Q() {
  return Q;
}).factory('moment', function () {
  return moment;
}).constant('queryParamGetter', _queryparamGetter2.default).name;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/utils.services.module.js
// module id = 18
// module chunks = 2